import { type JSX } from 'react/jsx-runtime';

import { useCallback, useEffect } from 'react';

import { useFirePostOfficeAnalyticsEvents } from '@post-office/analytics';

import { LeftNavCtaMessage } from '../../../common/components/LeftNavCtaMessage';

import { createRender, type HydrationResult } from './types';

const LAUNCHED_VARIANT = 'existing';

export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(({ onDismissed }) => {
	const { fireAnalyticsEvent } = useFirePostOfficeAnalyticsEvents();

	useEffect(() => {
		fireAnalyticsEvent(
			{
				eventType: 'ui',
				action: 'viewed',
				actionSubject: 'jiraRovoExtensionLeftNavCTA',
				actionSubjectId: 'post-office.rovo-extension-install-cta-left-nav.jira-side-nav',
			},
			{
				variant: LAUNCHED_VARIANT,
				source: 'jira-side-nav',
			},
		);
	}, [fireAnalyticsEvent]);

	const handleDismissWithAnalytics = useCallback(() => {
		fireAnalyticsEvent(
			{
				eventType: 'ui',
				action: 'clicked',
				actionSubject: 'jiraRovoExtensionLeftNavCTA',
				actionSubjectId: 'post-office.rovo-extension-install-cta-left-nav.dismiss',
			},
			{
				variant: LAUNCHED_VARIANT,
				source: 'jira-side-nav',
			},
		);
		onDismissed();
	}, [fireAnalyticsEvent, onDismissed]);

	const handleLinkClickAnalytics = useCallback(() => {
		fireAnalyticsEvent(
			{
				eventType: 'ui',
				action: 'clicked',
				actionSubject: 'jiraRovoExtensionLeftNavCTA',
				actionSubjectId: 'post-office.rovo-extension-install-cta-left-nav.install',
			},
			{
				variant: LAUNCHED_VARIANT,
				source: 'jira-side-nav',
			},
		);
	}, [fireAnalyticsEvent]);

	return (
		<LeftNavCtaMessage
			handleOnDismissed={handleDismissWithAnalytics}
			onSideNavClick={() => {
				handleLinkClickAnalytics();
				return null;
			}}
		/>
	);
});

export default render;
